import { render } from "./Terms.vue?vue&type=template&id=1274bbfb"
const script = {}

import "./Terms.vue?vue&type=style&index=0&id=1274bbfb&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__